import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WhatsAppEnrichmentState {
  numbers: Record<string, string>; // affAbo -> whatsapp number
  fetched: string[]; // affAbos that have been fetched (even if no number returned)
  failed: string[]; // affAbos that failed to fetch
}

const initialState: WhatsAppEnrichmentState = {
  numbers: {},
  fetched: [],
  failed: [],
};

const whatsAppEnrichmentSlice = createSlice({
  name: "whatsAppEnrichment",
  initialState,
  reducers: {
    addWhatsAppNumbers: (
      state,
      action: PayloadAction<{
        affAbos: string[];
        numbers: Record<string, string | undefined>;
      }>,
    ) => {
      const { affAbos, numbers } = action.payload;
      state.fetched.push(...affAbos);
      for (const affAbo of affAbos) {
        const number = numbers[affAbo];
        if (number) {
          state.numbers[affAbo] = number;
        }
      }
    },
    markWhatsAppEnrichmentFailed: (
      state,
      action: PayloadAction<{
        affAbos: string[];
      }>,
    ) => {
      state.failed.push(...action.payload.affAbos);
    },
  },
});

export const { addWhatsAppNumbers, markWhatsAppEnrichmentFailed } = whatsAppEnrichmentSlice.actions;
export default whatsAppEnrichmentSlice.reducer;
